// extracted by mini-css-extract-plugin
module.exports = {"authWrapper":"AuthLayout_auth-wrapper__3v25h","background":"AuthLayout_background__1KZi6","logo":"AuthLayout_logo__2TGIr"};